import { render, staticRenderFns } from "./TextualGridWidget.vue?vue&type=template&id=71dc6c7e&"
import script from "./TextualGridWidget.vue?vue&type=script&lang=ts&"
export * from "./TextualGridWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports